import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { NumberField } from 'src/Libs/inputs/react-hook-form'
import { ACTIVE_POWER_FUNCTION_MODEL, ActivePowerFunctionWithValidations } from '../../types/common'
import { ActivePowerSettingsModel } from '../../types/grid-and-system-protection.model'
import { getChangedFieldStyle } from '../../utils'
import { getFirstFieldDisabledState, getSecondFieldDisabledState, getFulcrumFieldHasChangedValues } from './helpers'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
import { useFarmContext } from 'src/Elements/Farm'
type Props = {
  index: number
  selectedFunction: ACTIVE_POWER_FUNCTION_MODEL
  fulcrum: [number | null, number | null]
  fulcrums: ActivePowerSettingsModel['fulcrums']
}

const ActivePowerSettingsTableRow: React.FC<Props> = ({ index, selectedFunction, fulcrum, fulcrums }) => {
  const fulcrumItem = fulcrums?.find(f => selectedFunction in f)
  const { isFarm, isFarmMasterSelected } = useFarmContext()
  const { hasInstallationWritingRights } = useInstallationAccessRightsContext()

  const canEdit = isFarm ? hasInstallationWritingRights && isFarmMasterSelected : hasInstallationWritingRights
  if (!fulcrumItem) return null

  const fieldLimits: ActivePowerFunctionWithValidations['limits'] = Object.values(fulcrumItem)[0].limits

  const isFirstFieldDisabled = getFirstFieldDisabledState(fieldLimits, fulcrum[0], index)
  const isSecondFieldDisabled = getSecondFieldDisabledState(fieldLimits, fulcrum[1], index)

  const { firstFieldHasChangedValue, secondFieldHasChangedValue } = getFulcrumFieldHasChangedValues(selectedFunction, fulcrumItem, index)

  return (
    <TableRow>
      <TableCell scope="row">{index + 1}</TableCell>
      <TableCell align="right">
        <NumberField
          name={`fulcrums.${selectedFunction}.${index}.0`}
          disabled={isFirstFieldDisabled || !canEdit}
          sx={getChangedFieldStyle(firstFieldHasChangedValue)}
          fullWidth
        />
      </TableCell>
      <TableCell align="right">
        <NumberField
          name={`fulcrums.${selectedFunction}.${index}.1`}
          disabled={isSecondFieldDisabled || !canEdit}
          sx={getChangedFieldStyle(secondFieldHasChangedValue)}
          fullWidth
        />
      </TableCell>
    </TableRow>
  )
}

export default ActivePowerSettingsTableRow
